<template>
  <el-container>
    <el-aside v-if="userAccount" class="main-aside">
      <el-container>
        <el-header class="left-houselist">
          <el-input placeholder="请输入小区名称" v-model="likeData"></el-input>
          <el-button type="primary" @click="getHousingList()">查询</el-button>
        </el-header>
        <el-main>
          <el-table
            :data="tableData"
            :show-header="false"
            ref="tablesure"
            highlight-current-row
            default-expand-all
            @row-click="houseClick"
            row-key="userId"
            :tree-props="{ children: 'users' }"
          >
            <el-table-column prop="userName" label="名字"> </el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </el-aside>
    <el-main class="main-main">
      <el-container>
        <el-header>
          <h3>公告投放</h3>
        </el-header>
        <el-main>
          <el-button type="primary" @click="addstatus = true"
            >添加广告</el-button
          >
          <div class="upload-advertise comm-adver" v-if="addstatus">
            <el-row>
              <el-col :span="6">公告标题:</el-col>
              <el-col :span="18">
                <el-input
                  class="max-w-i"
                  placeholder="请输入标题"
                  v-model="advertiseData.noticeName"
                ></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">公告文件:</el-col>
              <el-col :span="6" class="m-w-c">
                <el-upload
                  class="upload-demo"
                  action=""
                  multiple
                  :limit="1"
                  :auto-upload="false"
                  list-type="picture"
                  :on-remove="removefile"
                  :on-change="changefile"
                >
                  <el-button v-if="uploadStatus" size="medium" type="primary"
                    >点击上传</el-button
                  >
                  <div v-if="uploadStatus" slot="tip" class="el-upload__tip">
                    <b>可以不上传：</b>文件不能大于2M
                  </div>
                </el-upload>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">公告文本：</el-col>
              <el-col :span="18">
                <el-input
                  type="textarea"
                  :row="4"
                  :autosize="{ minRows: 4, maxRows: 8 }"
                  placeholder="请输入内容"
                  v-model="advertiseData.contentText"
                >
                </el-input>
              </el-col>
            </el-row>
            <div class="suer-btn">
              <el-button type="danger" @click="addstatus = false"
                >取消上传</el-button
              >
              <el-button type="primary" @click="suerUpload()"
                >确定上传</el-button
              >
            </div>
          </div>
          <p>已有公告</p>
          <div class="show-advertise comm-adver">
            <div>
              <el-table :data="advertiseList">
                <el-table-column
                  prop="noticeName"
                  label="公告名称"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="createTime"
                  label="创建时间"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="createBy"
                  label="创建者账号"
                  align="center"
                ></el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button type="primary" @click="queryAdvertise(scope.row)"
                      >查看公告</el-button
                    >
                    <el-button type="danger" @click="removeAdvertise(scope.row)"
                      >删除公告</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 查看公告弹框 -->
            <el-dialog title="公告详情" :visible.sync="advertiseVisible">
              <el-row>
                <el-col :span="6">公告文件：</el-col>
                <el-col :span="18">
                  <el-link
                    type="success"
                    :href="advertiseAddress"
                    target="_blank"
                    >预览文件</el-link
                  >
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">公告文本：</el-col>
                <el-col :span="18">
                  <el-input
                    :disabled="true"
                    type="textarea"
                    :row="4"
                    :autosize="{ minRows: 4, maxRows: 8 }"
                    v-model="queryContentText"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </el-dialog>
          </div>
        </el-main>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      userAccount: true,
      tableData: [], //小区列表
      likeData: "", //模糊查询
      advertiseData: {
        uid: "", //登陆ID
        unitId: "", //小区ID
        contentText: "",
        noticeName: ""
      },
      addstatus: false,
      fileList: [], //上传文件列表
      uploadStatus: true, //选择文件状态
      advertiseList: [], //公告数据
      advertiseAddress: "", //文件地址
      queryContentText: "", //文件内容
      advertiseVisible: false //弹框
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(["userinfo"])
  },
  created() {
    this.getHousingList();
  },
  methods: {
    getHousingList() {
      // if (this.userinfo.account == "admin") {
      //   this.userAccount = false;
      // } else {
      // }
      let url = "/dapi/u/likeSelectUserInfo";
      let params = {
        uid: this.userinfo.uid,
        likeData: this.likeData
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.tableData = [];
          data.data.map(item => {
            if (item.userRoleCode == 3 || item.userRoleCode == 9) {
              this.tableData.push(item);
            }
            if (item.users && item.users.length > 0) {
              let users = item.users.filter(
                k => k.userRoleCode == 3 || k.userRoleCode == 9
              );
              item.users = users;
              this.tableData.push(item);
            }
          });
          // this.tableData = data.data;
          this.$nextTick(() => {
            this.$refs.tablesure.setCurrentRow(this.tableData[0]);
          });
          if (this.tableData[0].users != undefined) {
            if (
              this.tableData[0].users != "" &&
              this.tableData[0].users.length > 0
            ) {
              this.houseClick(this.tableData[0].users[0]);
              return;
            }
          }
          this.houseClick(this.tableData[0]);
        }
      });
    },
    houseClick(row) {
      this.advertiseData.unitId = row.userId; //获取小区ID
      this.advertiseData.uid = this.userinfo.uid; //获取登陆ID
      this.queryAdvertiseList();
    },
    /*
     **  @description 移除文件
     **  @param {}
     **  @return
     **  @author shipingan
     */
    removefile() {
      this.uploadStatus = true;
    },
    /*
     **  @description 选择文件
     **  @param {}
     **  @return
     **  @author shipingan
     */
    changefile(file) {
      this.uploadStatus = false;
      this.fileList = file;
    },
    /*
     **  @description 上传文件
     **  @param {}
     **  @return
     **  @author shipingan
     */
    suerUpload() {
      if (this.fileList.length > 0) {
        if (this.fileList.raw.size > 1024 * 1024 * 2) {
          this.$message.error("文件过大！");
          return;
        }
      }
      if (this.advertiseData.contentText == "") {
        this.$message.error("公告文本不能为空！");
        return;
      }
      if (this.advertiseData.noticeName == "") {
        this.$message.error("公告标题不能为空！");
        return;
      }
      let url = "/dapi/u/uploadNotice";
      let formData = new FormData();
      formData.append("file", this.fileList.raw);
      formData.append("uid", this.advertiseData.uid);
      formData.append("unitId", this.advertiseData.unitId);
      formData.append("contentText", this.advertiseData.contentText);
      formData.append("noticeName", this.advertiseData.noticeName);
      this.$axios.post(url, formData).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.$message({
            type: "success",
            message: "上传成功"
          });
          this.addstatus = false;
          this.uploadStatus = true;
          this.queryAdvertiseList();
        }
      });
    },
    /*
     **  @description 获取广告
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryAdvertiseList() {
      this.advertiseList = [];
      let url = "/dapi/u/queryNotice";
      let params = { unitId: this.advertiseData.unitId };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.advertiseList = data.data;
        }
      });
    },
    /*
     **  @description 删除公告
     **  @param {}
     **  @return
     **  @author shipingan
     */
    removeAdvertise(row) {
      let params = { noticeId: row.noticeId };
      let url = "/dapi/u/deleteNotice";
      this.$confirm("此操作将永久删除该, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios.post(url, this.$qs.stringify(params)).then(res => {
            let data = res.data;
            if (data.status == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.queryAdvertiseList();
            } else {
              this.$message.error(data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    /*
     **  @description 查看公告
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryAdvertise(row) {
      this.advertiseAddress = row.contentFile;
      this.queryContentText = row.contentText;
      this.advertiseVisible = true;
    }
  }
};
</script>
<style lang="less" scoped>
@box-shadow: 0px 0px 10px #ccc;
.el-container {
  height: 100%;
  .main-aside {
    box-shadow: @box-shadow;
    .left-houselist {
      display: flex;
      box-sizing: border-box;
      padding: 16px 20px;
      justify-content: space-between;
      box-shadow: @box-shadow;
      .el-input {
        width: 180px;
        margin-right: 10px;
      }
    }
    .el-main {
      padding-top: 10px;
    }
  }
  .main-main {
    padding: 0;
    .el-header {
      text-align: left;
      box-shadow: @box-shadow;
      min-width: 400px;
    }
    .el-main {
      text-align: left;
      .comm-adver {
        min-width: 900px;
        padding: 10px 0;
        box-shadow: @box-shadow;
        margin: 10px 0;
        p {
          margin: 0;
          color: #409eff;
          padding-left: 20px;
        }
        .el-row {
          padding-left: 20px;
          margin: 10px;
          box-shadow: @box-shadow;
          .el-col {
            padding: 10px;
            .max-w-i {
              max-width: 200px;
            }
          }
          .m-w-c {
            min-width: 260px;
          }
        }
        .suer-btn {
          text-align: center;
          padding: 10px 0;
        }
      }
    }
  }
}
</style>
